export default __webpack_public_path__ + "static/bee-abe79af9a00f0e5d090ee31fa2083694.png";